<div class="w-svw h-svh max-h-svh max-w-svw">
  @if (facadeGetConfig.data(); as config) {
    <router-outlet/>
  }
</div>
<app-toast/>
<app-modal-swal/>
<app-spinner-global/>
